import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

export default function BillingPage() {
  const { keycloak } = useAuth();
  const token = keycloak.token;

  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('');
  const [currentPlan, setCurrentPlan] = useState('free');

  const plans = [
    { id: 'free', name: 'Gratuit' },
    { id: 'pro', name: 'Pro (9€/mois)' },
    { id: 'enterprise', name: 'Entreprise (29€/mois)' },
  ];

  const features = [
    { label: 'Médias inclus', values: { free: '5', pro: '50', enterprise: 'Illimités' } },
    { label: 'Montage assisté par IA', values: { free: false, pro: true, enterprise: true } },
    { label: 'Exports haute qualité', values: { free: false, pro: false, enterprise: true } },
    { label: 'Statistiques de vues', values: { free: false, pro: true, enterprise: true } },
    { label: 'Collaboration multi-utilisateurs', values: { free: false, pro: false, enterprise: true } },
    { label: 'Support client', values: { free: 'Aucun', pro: 'Standard', enterprise: 'Prioritaire' } }
  ];

  useEffect(() => {
    if (!token) return;
    fetch("http://localhost:3001/billing", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setCurrentPlan(data.currentPlan || 'free'))
      .catch(() => {
        setMessage("Erreur lors du chargement du plan.");
        setVariant("danger");
      });
  }, [token]);

  const handleSubscribe = (planId) => {
    fetch("http://localhost:3001/billing", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ plan: planId })
    })
      .then(res => {
        if (res.ok) {
          setCurrentPlan(planId);
          setMessage("✅ Plan mis à jour !");
          setVariant("success");
        } else {
          setMessage("❌ Échec de la mise à jour.");
          setVariant("danger");
        }
      })
      .catch(() => {
        setMessage("Erreur réseau.");
        setVariant("danger");
      });
  };

  const pinterestCheck = <span style={{ fontSize: '1.2rem', color: '#111' }}>✔︎</span>;

  return (
    <div  className="container py-5" >
      {message && (
        <div className={`alert alert-${variant} alert-dismissible`} role="alert">
          {message}
          <button type="button" className="btn-close" onClick={() => setMessage('')}></button>
        </div>
      )}
<br></br>
      <h2 className="fw-bold text-center mb-4">Mise à niveau vers un compte premium</h2>
      <p className="text-center text-muted mb-5">
        Comparez les plans pour choisir celui qui correspond à vos besoins.
      </p>

      <div className="table-responsive">
        <table className="table table-bordered text-center align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-start">Fonctionnalités</th>
              {plans.map(plan => (
                <th key={plan.id} className={currentPlan === plan.id ? 'table-primary' : ''}>
                  <div className="d-flex flex-column align-items-center">
                    <strong>{plan.name}</strong>
                    {currentPlan === plan.id && (
                      <span
                        className="px-2 py-1 mt-1"
                        style={{
                          fontSize: '0.75rem',
                          backgroundColor: '#e9ecef',
                          borderRadius: '12px',
                          color: '#333',
                          fontWeight: '500'
                        }}
                      >
                        Plan actuel
                      </span>
                    )}
                  </div>

                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {features.map((feature, i) => (
              <tr key={i}>
                <td className="text-start fw-medium">{feature.label}</td>
                {plans.map(plan => {
                  const value = feature.values[plan.id];
                  return (
                    <td key={plan.id}>
                      {value === true && pinterestCheck}
                      {value === false && <span className="text-muted">—</span>}
                      {typeof value === 'string' && <span>{value}</span>}
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr>
              <td></td>
              {plans.map(plan => (
                <td key={plan.id}>
                  {currentPlan === plan.id ? (
                    <button className="btn btn-outline-secondary" disabled>✔︎ Actif</button>
                  ) : (
                    <button className="btn btn-danger" onClick={() => handleSubscribe(plan.id)}>
                      Mettre à niveau
                    </button>
                  )}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
